import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import { arrayOf, object, shape, string } from 'prop-types'
import { Root, LinkCurrent, LinkPrev } from './breadcrumbs.styled'
import { useThemeProps } from '@mui/system'
import { cx } from '@emotion/css'

const Breadcrumbs = ({ ...inProps }) => {
	const props = useThemeProps({
		name: 'BHBreadcrumbs',
		props: inProps,
	})

	const { items, activeLinkProps, linkProps, ...rest } = props

	return (
		<Root className={cx('Breadcrumbs-root')} aria-label="breadcrumb" {...rest}>
			{items.map(({ title, url }, index) => {
				const last = index === items.length - 1
				return last ? (
					<LinkCurrent key={index} href={null} {...activeLinkProps}>
						{title}
					</LinkCurrent>
				) : (
					<LinkPrev key={index} href={url} {...linkProps}>
						{title}
					</LinkPrev>
				)
			})}
		</Root>
	)
}

Breadcrumbs.defaultProps = {
	...MuiBreadcrumbs.defaultProps,
	items: [],
}

Breadcrumbs.propTypes = {
	...MuiBreadcrumbs.propTypes,
	/**
	 * Array of items to show
	 */
	items: arrayOf(
		shape({
			title: string,
			url: string,
		})
	),
	/**
	 * The props for decorate link item
	 */
	linkProps: object,
	/**
	 * The props for decorate active link item
	 */
	activeLinkProps: object,
	color: string,
}

export default Breadcrumbs
